/* eslint-disable func-names */
import React from 'react';
import _ from 'lodash';
import BitaCharts from '../../../../../bitaComponents/BitaCharts/BitaCharts';
import { activeRiskTheme } from '../../../../../bitaComponents/BitaCharts/Themes';
import { capitalizeText } from '../../../../../utils/utils';

export default ({ indexStats, index }) => {
  const reducer = (acc, current) => acc + current;
  const availableData = Object.values(
    _.get(indexStats, `[${index}].value['Active Performance']`, [0]),
  ).reduce(reducer);

  const getData = () => {
    if (indexStats && availableData !== 0) {
      return Object.values(_.get(indexStats, `[${index}].value['Active Performance']`, []));
    }
    return [];
  };

  return (
    <BitaCharts
      theme={activeRiskTheme}
      options={{
        xAxis: {
          categories:
            indexStats &&
            Object.keys(_.get(indexStats, `[${index}].value['Active Performance']`, [])).map(w =>
              capitalizeText(w.replace('_', ' ')),
            ),
        },
        series: [
          {
            name: '',
            data: getData(),
          },
        ],
        lang: {
          noData: "There's no data available for the time frame you've selected",
        },
        noData: {
          style: {
            fontWeight: 'bold',
            fontSize: '150px',
            color: '#f303f2',
          },
        },
      }}
      containerProps={{ style: { height: '310px', width: '100%' } }}
    />
  );
};
